import React from "react";
import { connectLeftSideMenu } from "./leftsidemenu.connect";
import { CONFIG, DownloadApk, IS_B2C } from "../../config/api.config";
import { useNavigate, Link, useLocation } from "react-router-dom";
import SVG_CricketIcon from "../../assets/images/svgs/cricket.svg?react";
import SVG_FootballIcon from "../../assets/images/svgs/football.svg?react";
import SVG_TennisIcon from "../../assets/images/svgs/tennis.svg?react";
import SVG_HorseIcon from "../../assets/images/svgs/horse.svg?react";
import SVG_GreyhoundIcon from "../../assets/images/svgs/greyhound.svg?react";
import SVG_ElectionIcon from "../../assets/images/svgs/election.svg?react";
import Svg_SpadeIcon from "../../assets/images/svgs/spade-dark.svg?react";
import SVG_CardDeckIcon from "../../assets/images/svgs/cards-deck.svg?react";
import SVG_CasinoNewIcon from "../../assets/images/svgs/casinoNewIcon.svg?react";
import SVG_SlotGamesIcon from "../../assets/images/svgs/SlotGamesIcon.svg?react";
import SVG_DiceIcon from "../../assets/images/svgs/dice.svg?react";
import SVG_DownloadIcon from "../../assets/images/svgs/download.svg?react";
import SVG_RocketIcon from "../../assets/images/svgs/rocket.svg?react";
import SVG_SportsBook from "../../assets/images/svgs/sportsBook.svg?react";
import SVG_SportsBook2 from "../../assets/images/svgs/sportsBook2.svg?react";
import SVG_BlogNews from "../../assets/images/svgs/BlogNews.svg?react";
import ContactUs from "../ContactUs/ContactUs";
import { USER_DATA } from "../../config/app.config";
import { toastr } from "react-redux-toastr";
import useTheme from "../../hooks/useTheme";

const LeftSideMenu = ({ setOpen, menu, auth, language, version, actions }) => {
  const location = useLocation();
  const navigate = useNavigate();

  let userData = {};

  try {
    userData = JSON.parse(localStorage.getItem(USER_DATA) || "{}");
  } catch {
    userData = {};
  }

  const isSportAvailable = (id) => {
    return menu.some((sport) => sport.sport_id === id);
  };

  const getMenu = (data) => {
    actions
      .requestRacingPageData(data)
      .catch((e) => console.log("menu error = ", e));
  };

  const [theme, setTheme] = useTheme();

  return (
    <>
      <aside>
        <div
          className="fixed top-0 left-0 z-50 w-full h-full  bg-opacity-50 block"
          onClick={() => {
            setOpen(false);
          }}
        >
          <div className="undefined">
            <div
              className="fixed transition-all ease-in-out openDrawer origin-left top-0 left-0 z-50 w-[70%] max-w-sm h-full overflow-y-auto bg-bg_Quaternary-side-right shadow-lg  "
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <ul className="divide-y min-h-full pb-10 divide-divide_color_primary6 relative font-lato">
                {(isSportAvailable("QT") || isSportAvailable("GAP")) && (
                  <li className="flex items-center">
                    <Link
                      className="flex items-center justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to={"#"}
                      onClick={(e) => {
                        e.preventDefault();
                        setOpen(false);
                        if (auth) {
                          if (userData?.is_demo) {
                            toastr.error("", "Please login from your read ID.");
                            return;
                          }
                          navigate("/casino-live/SPB-aviator/SPB");
                        } else {
                          actions.setLoginNew(true);
                          actions.setLoginNavigationData({
                            page: isSportAvailable("QT")
                              ? "casino-live/SPB-aviator/SPB"
                              : "gapcasino-live/151027/Virtual/MAC88",
                            ids: [],
                          });
                        }
                      }}
                    >
                      <SVG_RocketIcon />
                      <span>Aviator</span>
                    </Link>
                    {/* <button
                      id="theme-toggle"
                      onClick={() => {
                        setTheme(theme === "dark" ? "light" : "dark");
                        setTimeout(() => {
                          setOpen(false);
                        }, 50);
                      }}
                      type="button"
                      className={` mr-2 w-[30] h-[30] ${theme === "dark" ? "text-gray-300 border-gray-300" : "text-gray-800 border-gray-500"} border-2 rounded-lg text-sm p-1`}
                    >
                      <svg
                        id="theme-toggle-dark-icon"
                        className={`${theme === "dark" ? "hidden" : ""} w-5 h-5`}
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path>
                      </svg>
                      <svg
                        id="theme-toggle-light-icon"
                        className={`${theme === "dark" ? "" : "hidden"} w-5 h-5`}
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                          fillRule="evenodd"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </button> */}
                  </li>
                )}
                <li>
                  <h3 className=" w-full h-max px-6 pt-4 pb-2 text-[13px] text-text_Ternary-new uppercase font-normal">
                    Sports
                  </h3>
                  {isSportAvailable("4") && (
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to="/sports-page/Cricket/4"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <SVG_CricketIcon width={19} height={18} />
                      <span>Cricket</span>
                    </Link>
                  )}
                  {isSportAvailable("1") && (
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to="/sports-page/football/1"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <SVG_FootballIcon width={19} height={19} />
                      <span>Football</span>
                    </Link>
                  )}
                  {isSportAvailable("2") && (
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to="/sports-page/tennis/2"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <SVG_TennisIcon width={20} height={20} />
                      <span>Tennis</span>
                    </Link>
                  )}
                  {isSportAvailable("7") && (
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to={"/horse-racing"}
                      onClick={() => {
                        const horseRacing = { sport_id: "7" };

                        getMenu(horseRacing);
                        setOpen(false);
                      }}
                    >
                      <SVG_HorseIcon width={18} height={22} />
                      <span>Horse Racing</span>
                    </Link>
                  )}
                  {isSportAvailable("4339") && (
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to={"/greyhound-racing"}
                      onClick={() => {
                        const horseRacing = { sport_id: "4339" };

                        getMenu(horseRacing);
                        setOpen(false);
                      }}
                    >
                      <SVG_GreyhoundIcon
                        width={21}
                        height={20}
                        // className={`${theme === "dark" ? "invert" : ""}`}
                        fill={
                          theme === "dark"
                            ? "var(--color-text-ternary)"
                            : "#000"
                        }
                      />
                      <span>Greyhound Racing</span>
                    </Link>
                  )}
                  {/* {isSportAvailable("2378961") && ( */}
                  <Link
                    className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                    to={"/election"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <SVG_ElectionIcon
                      width={21}
                      height={20}
                      className="election"
                    />
                    <span>Election</span>
                  </Link>
                  {/* )} */}
                </li>
                {(isSportAvailable("-100") || isSportAvailable("GAP")) && (
                  <li>
                    <h3 className=" w-full h-max px-6 pt-4 pb-2 text-[13px] text-text_Ternary-new uppercase font-normal">
                      Casino
                    </h3>
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        if (auth) {
                          if (userData?.is_demo) {
                            toastr.error("", "Please login from your read ID.");
                            return;
                          }
                          if (isSportAvailable("-100")) {
                            navigate("/livegames/aura/FAWK");
                          } else {
                            navigate("/casino-lobby/gapcasino/AURA");
                          }
                          if (
                            !location.pathname.includes("/livegames/aura/FAWK")
                          ) {
                            actions.openSlotCasinoPopUp();
                          }
                        } else {
                          actions.setLoginNew(true);

                          actions.setLoginNavigationData({
                            page: "livegames/aura/FAWK",
                            ids: [],
                          });
                        }
                        setOpen(false);
                      }}
                    >
                      <Svg_SpadeIcon
                        width={20}
                        height={20}
                        className="election"
                      />
                      <span>Indian Card Games</span>
                    </Link>
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to={"#"}
                      onClick={(e) => {
                        e.preventDefault();
                        setOpen(false);
                        if (auth) {
                          if (userData?.is_demo) {
                            toastr.error("", "Please login from your read ID.");
                            return;
                          }
                          navigate("/casino-lobby/casino");
                          if (
                            !location.pathname.includes("/casino-lobby/casino")
                          ) {
                            actions.openSlotCasinoPopUp();
                          }
                        } else {
                          actions.setLoginNew(true);
                          actions.setLoginNavigationData({
                            page: "casino-lobby/casino",
                            ids: [],
                          });
                        }
                      }}
                    >
                      <SVG_CasinoNewIcon width={20} height={20} />
                      <span>Casino</span>
                    </Link>
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to={"#"}
                      onClick={(e) => {
                        e.preventDefault();
                        setOpen(false);
                        if (auth) {
                          if (userData?.is_demo) {
                            toastr.error("", "Please login from your read ID.");
                            return;
                          }
                          navigate("/casino-lobby/slot-games");
                          if (
                            !location.pathname.includes(
                              "/casino-lobby/slot-games",
                            )
                          ) {
                            actions.openSlotCasinoPopUp();
                          }
                        } else {
                          actions.setLoginNew(true);
                          actions.setLoginNavigationData({
                            page: "casino-lobby/slot-games",
                            ids: [],
                          });
                        }
                      }}
                    >
                      <SVG_SlotGamesIcon width={20} height={20} />
                      <span>Slot Games</span>
                    </Link>
                  </li>
                )}

                {isSportAvailable("GAP") && (
                  <Link
                    className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                    to={"#"}
                    onClick={(e) => {
                      e.preventDefault();
                      if (auth) {
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                          return;
                        }
                        navigate("/casino-lobby/gapcasino");
                        if (
                          !location.pathname.includes("/casino-lobby/gapcasino")
                        ) {
                          actions.openSlotCasinoPopUp();
                        }
                      } else {
                        actions.setLoginNew(true);
                        actions.setLoginNavigationData({
                          page: "casino-lobby/gapcasino",
                          ids: [],
                        });
                      }
                      setOpen(false);
                    }}
                  >
                    <SVG_CasinoNewIcon width={20} height={20} />
                    <span> MAC88</span>
                  </Link>
                )}

                <li>
                  <Link
                    className="flex items-center justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                    to={"/sports-page/Sportsbook/0"}
                    onClick={() => {
                      actions.setIsNavigationID("0");
                      actions.setIsNavigationName("Sportsbook");
                      setOpen(false);
                    }}
                  >
                    <SVG_SportsBook2 />
                    <span>Sportsbook</span>
                  </Link>
                </li>

                {IS_B2C && (
                  <li>
                    <h3 className=" w-full h-max px-6 pt-4 pb-2 text-[13px] text-text_Ternary-new uppercase font-normal">
                      Others
                    </h3>
                    <div
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      // to="#"
                      onClick={DownloadApk}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="var(--icon-color-brand-secondary)"
                      >
                        <path
                          d="M2.86361 6.323C2.20466 6.323 1.59089 6.84291 1.59089 7.48341V12.4518C1.59089 13.0926 2.20466 13.6122 2.86361 13.6122C3.52225 13.6122 4.13634 13.0926 4.13634 12.4518V7.48373C4.13634 6.84291 3.52225 6.323 2.86361 6.323Z"
                          fill="var(--icon-color-brand-secondary)"
                        ></path>
                        <path
                          d="M13.2392 1.67272L13.4613 1.3469L13.6837 1.0249L14.1791 0.301037C14.2412 0.21131 14.2154 0.0916734 14.1241 0.0328097C14.0337 -0.0273267 13.9087 -0.0021903 13.8495 0.0869006L13.0932 1.18876L12.8657 1.52063C12.1469 1.2489 11.346 1.09745 10.5 1.09745C9.65584 1.09745 8.85339 1.24922 8.13462 1.52063L7.90839 1.18908L7.68471 0.863583L7.15334 0.087537C7.09193 -0.00187211 6.96848 -0.0254176 6.87684 0.0334461C6.78616 0.0926279 6.76102 0.212264 6.82148 0.301673L7.31657 1.02586L7.53898 1.34817L7.76234 1.67304C6.07471 2.43826 4.93275 3.95472 4.93275 5.54563H16.0675C16.0675 3.95472 14.9259 2.43826 13.2392 1.67272ZM8.11393 4.00086C7.78334 4.00086 7.51702 3.7409 7.51702 3.41986C7.51702 3.09881 7.78334 2.84013 8.11393 2.84013C8.44357 2.84013 8.71052 3.09881 8.71052 3.41986C8.71052 3.7409 8.44389 4.00086 8.11393 4.00086ZM12.8867 4.00086C12.5564 4.00086 12.2894 3.7409 12.2894 3.41986C12.2894 3.09881 12.5564 2.84013 12.8867 2.84013C13.2163 2.84013 13.4833 3.09881 13.4833 3.41986C13.4833 3.7409 13.2163 4.00086 12.8867 4.00086Z"
                          fill="var(--icon-color-brand-secondary)"
                        ></path>
                        <path
                          d="M2.92025 8.91666C2.4242 8.91666 1.90907 8.44862 1.59089 7.7063V12.452C1.59089 13.0928 2.20466 13.6124 2.86361 13.6124C3.52225 13.6124 4.13634 13.0928 4.13634 12.452V7.95384C3.81816 8.55012 3.35807 8.91666 2.92025 8.91666Z"
                          fill="var(--icon-color-brand-secondary)"
                        ></path>
                        <path
                          d="M18.1363 6.323C17.4774 6.323 16.8636 6.84291 16.8636 7.48341V12.4518C16.8636 13.0926 17.4774 13.6122 18.1363 13.6122C18.795 13.6122 19.4091 13.0926 19.4091 12.4518V7.48373C19.4091 6.84291 18.795 6.323 18.1363 6.323Z"
                          fill="var(--icon-color-brand-secondary)"
                        ></path>
                        <path
                          d="M18.193 8.91691C17.6969 8.91691 17.1818 8.44886 16.8636 7.70654V12.4522C16.8636 13.093 17.4774 13.6126 18.1363 13.6126C18.795 13.6126 19.4091 13.093 19.4091 12.4522V7.95409C19.0909 8.55036 18.6308 8.91691 18.193 8.91691Z"
                          fill="var(--icon-color-brand-secondary)"
                        ></path>
                        <path
                          d="M13.4833 3.41959C13.4833 3.74063 13.2163 4.00059 12.8867 4.00059C12.5564 4.00059 12.2894 3.74063 12.2894 3.41959C12.2894 3.24554 12.3693 3.09186 12.4937 2.98559C11.8647 2.88059 11.1955 2.823 10.5 2.823C9.80443 2.823 9.13562 2.88059 8.50625 2.98559C8.63098 3.09154 8.71084 3.24554 8.71084 3.41959C8.71084 3.74063 8.44389 4.00059 8.11425 4.00059C7.78366 4.00059 7.51734 3.74063 7.51734 3.41959C7.51734 3.3375 7.53548 3.25954 7.56698 3.18859C6.61307 3.43932 5.79343 3.80523 5.17489 4.25482C5.01898 4.66432 4.93275 5.2275 4.93275 5.54568H16.0675C16.0675 5.2275 15.9813 4.66463 15.8257 4.25545C15.2075 3.80523 14.3875 3.43868 13.4343 3.18795C13.4654 3.25891 13.4833 3.33782 13.4833 3.41959Z"
                          fill="var(--icon-color-brand-secondary)"
                        ></path>
                        <path
                          d="M10.5 6.11108C8.35637 6.11108 6.61107 6.11108 5.09089 6.11108V14.839C5.09089 15.5151 5.49689 16.0455 6.19275 16.0455H7.10116C7.06998 16.0455 6.99998 16.275 6.99998 16.3876V18.8395C6.99998 19.4803 7.61439 19.9999 8.27271 19.9999C8.93134 19.9999 9.54543 19.4803 9.54543 18.8395V16.3876C9.54543 16.275 9.42262 16.0455 9.39239 16.0455H11.6082C11.578 16.0455 11.4545 16.275 11.4545 16.3876V18.8395C11.4545 19.4803 12.0677 19.9999 12.726 19.9999C13.3859 19.9999 14 19.4803 14 18.8395V16.3876C14 16.275 13.9303 16.0455 13.8991 16.0455H14.8088C15.5047 16.0455 15.9091 15.5151 15.9091 14.839V6.11108C14 6.28272 12.6436 6.11108 10.5 6.11108Z"
                          fill="var(--icon-color-brand-secondary)"
                        ></path>
                      </svg>
                      <span>Download APK</span>
                    </div>
                    <Link className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold">
                      <SVG_BlogNews />
                      <span>Blogs & News</span>
                    </Link>
                  </li>
                )}
                {IS_B2C && (
                  <li>
                    <h3 className=" w-full h-max px-6 pt-4 pb-2 text-[13px] text-text_Ternary-new uppercase font-normal">
                      Help &amp; Support
                    </h3>
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to="/responsible-gambling"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="var(--icon-color-brand-secondary)"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path d="M11.884 2.007l.114 -.007l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021z"></path>
                      </svg>
                      <span>Responsible Gambling</span>
                    </Link>
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to="/privacy-policy"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="var(--icon-color-brand-secondary)"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <path d="M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-2.5 9.66a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path>
                      </svg>
                      <span>Privacy Policy</span>
                    </Link>
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to="/exclusion-policy"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_532_33819)">
                          <path
                            d="M17.4212 5.71875C17.4217 5.22552 17.23 4.76169 16.8815 4.41278C16.5329 4.06386 16.0693 3.87166 15.5761 3.87166C15.3414 3.87166 15.1169 3.91641 14.91 3.99702L14.9119 2.99216C14.9131 2.49849 14.7217 2.03415 14.373 1.68465C14.0243 1.33518 13.5605 1.14267 13.0668 1.14267H13.0396C12.6696 1.14267 12.3248 1.25276 12.0355 1.44135C11.9754 1.35638 11.9082 1.27557 11.8331 1.20041C11.4845 0.850941 11.0206 0.658508 10.527 0.658508H10.4935C9.65021 0.658508 8.93778 1.22737 8.71846 2.0013C8.49239 1.90228 8.24297 1.84694 7.98076 1.84694H7.95937C6.94198 1.84694 6.11428 2.67464 6.11428 3.69203V7.41592C5.90383 7.33291 5.6749 7.28675 5.43529 7.28675C4.41166 7.28675 3.57886 8.11951 3.57886 9.14314V13.7416C3.57886 17.5556 6.68181 20.6585 10.4958 20.6585C12.3451 20.6585 14.0833 19.9379 15.3901 18.6293C16.6969 17.3208 17.4152 15.5817 17.4128 13.7324L17.4101 11.7676L17.4212 5.71875ZM16.2353 13.7339C16.2373 15.2685 15.6413 16.7115 14.5569 17.7973C13.4726 18.8831 12.0303 19.481 10.4958 19.481C7.33101 19.481 4.7563 16.9063 4.7563 13.7416V9.14314C4.7563 8.76876 5.0609 8.46419 5.43529 8.46419C5.80968 8.46419 6.11428 8.76876 6.11428 9.14314V12.2364C6.11428 12.5615 6.37787 12.8251 6.703 12.8251C7.74845 12.8251 8.59899 13.6756 8.59899 14.7211V15.6845C8.59899 16.0097 8.86258 16.2732 9.18771 16.2732C9.51284 16.2732 9.77643 16.0097 9.77643 15.6845V14.7211C9.77643 13.2276 8.70579 11.9796 7.29172 11.7042V3.69203C7.29172 3.32388 7.59122 3.02438 7.95937 3.02438H7.98076C8.34886 3.02438 8.64833 3.32384 8.64841 3.69191V9.12258C8.64841 9.44771 8.912 9.7113 9.23713 9.7113C9.56226 9.7113 9.82585 9.44771 9.82585 9.12258C9.82585 8.25056 9.82585 3.23667 9.82585 2.50356C9.82585 2.13541 10.1253 1.83591 10.4935 1.83591H10.527C10.7056 1.83591 10.8735 1.90554 10.9996 2.03199C11.1257 2.15841 11.195 2.32643 11.1946 2.50521C11.1907 4.47459 11.1849 7.1705 11.1816 9.12689C11.1809 9.45202 11.444 9.71612 11.7691 9.71675H11.7703C12.0949 9.71675 12.3583 9.45395 12.359 9.12917C12.3615 7.80522 12.3685 4.25347 12.3719 2.98615C12.3728 2.61887 12.6723 2.32003 13.0396 2.32003H13.0668C13.2454 2.32003 13.4133 2.38966 13.5395 2.51616C13.6656 2.64261 13.7349 2.81067 13.7344 2.98957C13.7307 4.90393 13.7245 7.93124 13.7215 9.82908C13.7209 10.1542 13.984 10.4183 14.3091 10.4189H14.3103C14.6349 10.4189 14.8984 10.1561 14.899 9.83128C14.8998 9.53923 14.9056 5.83932 14.9085 5.71318C14.9103 5.34692 15.2098 5.04895 15.5761 5.04895C15.7546 5.04895 15.9223 5.11846 16.0485 5.24476C16.1746 5.37102 16.244 5.53884 16.2438 5.71687L16.2327 11.7672L16.2353 13.7339Z"
                            fill="var(--icon-color-brand-secondary)"
                          ></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_532_33819">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0.5 0.658508)"
                            ></rect>
                          </clipPath>
                        </defs>
                      </svg>
                      <span>Exclusion Policy</span>
                    </Link>
                    <Link
                      className="flex items-center h-full justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                      to="/rules-regulations"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_532_33802)">
                          <path
                            d="M16.2798 1.92035H13.0977V3.20935H15.6764C16.0334 3.20935 16.3209 3.49815 16.3209 3.85252V7.55723V10.2598V18.7237C16.3209 19.08 16.0334 19.3682 15.6764 19.3682H9.14729H8.61606H5.31938C4.96368 19.3682 4.67687 19.08 4.67687 18.7237V3.85252C4.67687 3.49815 4.96368 3.20935 5.31938 3.20935H7.93778V1.92035H4.67687C3.96348 1.92035 3.38721 2.49795 3.38721 3.21001V19.3688C3.38721 20.0829 3.96348 20.6585 4.67687 20.6585H7.80464H10.5489H16.2798C16.9939 20.6585 17.6125 20.0829 17.6125 19.3688V9.35361V7.92287V3.21001C17.6125 2.49795 16.9939 1.92035 16.2798 1.92035Z"
                            fill="var(--icon-color-brand-secondary)"
                          ></path>
                          <path
                            d="M7.48542 3.94526C7.20987 3.94526 6.9873 4.09893 6.9873 4.28837C6.9873 4.47914 6.9873 4.97195 6.9873 4.97195H14.0119C14.0119 4.97195 14.0119 4.47914 14.0119 4.28837C14.0119 4.09959 13.786 3.94526 13.5118 3.94526H12.0121V1.14868C10.4748 0.0570678 8.97843 1.13013 8.97843 1.13013L8.9824 3.94526H7.48542Z"
                            fill="var(--icon-color-brand-secondary)"
                          ></path>
                          <path
                            d="M14.7279 8.08316H6.27124V9.70997H14.7279V8.08316Z"
                            fill="var(--icon-color-brand-secondary)"
                          ></path>
                          <path
                            d="M14.7279 11.7925H6.27124V13.418H14.7279V11.7925Z"
                            fill="var(--icon-color-brand-secondary)"
                          ></path>
                          <path
                            d="M14.7279 15.6529H6.27124V17.2797H14.7279V15.6529Z"
                            fill="var(--icon-color-brand-secondary)"
                          ></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_532_33802">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(0.5 0.658508)"
                            ></rect>
                          </clipPath>
                        </defs>
                      </svg>
                      <span>Rules &amp; Regulations</span>
                    </Link>
                  </li>
                )}
                <span
                  className="flex items-center justify-start gap-x-2 w-full pl-6 pr-2 py-[11px] text-base text-text_Ternary-new whitespace-nowrap font-bold"
                  title="Language"
                  onClick={() => {
                    actions.setIsLangauage(true);
                    setOpen(false);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="var(--icon-color-brand-secondary)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                    <path d="M3.6 9h16.8"></path>
                    <path d="M3.6 15h16.8"></path>
                    <path d="M11.5 3a17 17 0 0 0 0 18"></path>
                    <path d="M12.5 3a17 17 0 0 1 0 18"></path>
                  </svg>
                  <span>
                    {language === "en"
                      ? "English"
                      : language === "hi"
                        ? "हिंदी"
                        : language === "mr"
                          ? "मराठी"
                          : language === "gu"
                            ? "ગુજરાતી"
                            : language === "kn"
                              ? "ಕನ್ನಡ"
                              : language === "bn"
                                ? "বাংলা"
                                : "Español"}{" "}
                    ({language?.toUpperCase()})
                  </span>
                </span>
                {IS_B2C && (
                  <li className=" px-3 py-2">
                    <span className="flex text-center text-text_Primary-new  text-sm xs:text-base font-medium">
                      Register online and play online
                    </span>
                  </li>
                )}
                <li className="p-1">
                  {location?.pathname == "/" && CONFIG.isContactUsVisisble && (
                    <ContactUs section={"Sidebar"} />
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </aside>

      {/* <aside>
        <div
          className="fixed top-0 left-0 z-50 w-full h-full  bg-opacity-50 block"
          onClick={() => {
            setOpen(false);
          }}
        >
          <div className="undefined">
            <div
              className="fixed transition-all ease-in-out openDrawer origin-left top-0 left-0 z-50 w-[70%] max-w-sm h-full overflow-y-auto bg-bg_Quaternary shadow-lg  "
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <ul className=" overflow-y-auto h-max divide-y">
                {isSportAvailable("QT") && (
                  <li className="px-3 py-2 transition-all rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] flex items-center justify-start gap-x-4 cursor-pointer">
                    <Link
                      className="flex items-center justify-start gap-x-4 w-full"
                      to={"#"}
                      onClick={(e) => {
                        e.preventDefault();
                        setOpen(false);
                        if (auth) {
                          if (userData?.is_demo) {
                            toastr.error("", "Please login from your read ID.");
                            return;
                          }
                          navigate("/casino-live/SPB-aviator/SPB");
                        } else {
                          actions.setLoginNew(true);
                          actions.setLoginNavigationData({
                            page: "casino-live/SPB-aviator/SPB",
                            ids: [],
                          });
                        }
                      }}
                    >
                      <span className=" w-3 h-auto xs:w-4">
                        <SVG_RocketIcon />
                      </span>
                      <span className=" font-medium text-sm xs:text-base">
                        Aviator
                      </span>
                    </Link>
                  </li>
                )}
                {isSportAvailable("4") && (
                  <li className="px-3 py-2 transition-all rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] flex items-center justify-start gap-x-4 cursor-pointer">
                    <Link
                      className="flex items-center justify-start gap-x-4 w-full"
                      to="/sports-page/Cricket/4"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <span className=" w-3 h-auto xs:w-4">
                        <SVG_CricketIcon width={19} height={18} />
                      </span>
                      <span className=" font-medium text-sm xs:text-base">
                        Cricket
                      </span>
                    </Link>
                  </li>
                )}
                {isSportAvailable("1") && (
                  <li className="px-3 py-2 transition-all rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] flex items-center justify-start gap-x-4 cursor-pointer">
                    <Link
                      className="flex items-center justify-start gap-x-4 w-full"
                      to="/sports-page/football/1"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <span className=" w-3 h-auto xs:w-4">
                        <SVG_FootballIcon width={19} height={19} />
                      </span>
                      <span className=" font-medium text-sm xs:text-base">
                        Football
                      </span>
                    </Link>
                  </li>
                )}
                {isSportAvailable("2") && (
                  <li className="px-3 py-2 transition-all rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] flex items-center justify-start gap-x-4 cursor-pointer">
                    <Link
                      className="flex items-center justify-start gap-x-4 w-full"
                      to="/sports-page/tennis/2"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <span className=" w-3 h-auto xs:w-4">
                        <SVG_TennisIcon width={20} height={20} />
                      </span>
                      <span className=" font-medium text-sm xs:text-base">
                        Tennis
                      </span>
                    </Link>
                  </li>
                )}
                {isSportAvailable("7") && (
                  <li className="px-3 py-2 transition-all rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] flex items-center justify-start gap-x-4 cursor-pointer">
                    <Link
                      className="flex items-center justify-start gap-x-4 w-full"
                      to={"/horse-racing"}
                      onClick={() => {
                        const horseRacing = { sport_id: "7" };

                        getMenu(horseRacing);
                        setOpen(false);
                      }}
                    >
                      <span className=" w-3 h-auto xs:w-4">
                        <SVG_HorseIcon width={18} height={22} />
                      </span>
                      <span className=" font-medium text-sm xs:text-base">
                        Horse Racing
                      </span>
                    </Link>
                  </li>
                )}
                {isSportAvailable("4339") && (
                  <li className="px-3 py-2 transition-all rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] flex items-center justify-start gap-x-4 cursor-pointer">
                    <Link
                      className="flex items-center justify-start gap-x-4 w-full"
                      to={"/greyhound-racing"}
                      onClick={() => {
                        const horseRacing = { sport_id: "4339" };

                        getMenu(horseRacing);
                        setOpen(false);
                      }}
                    >
                      <span className=" w-3 h-auto xs:w-4">
                        <SVG_GreyhoundIcon width={21} height={20} />
                      </span>
                      <span className=" font-medium text-sm xs:text-base">
                        Greyhound Racing
                      </span>
                    </Link>
                  </li>
                )}
                {isSportAvailable("2378961") && (
                  <li className="px-3 py-2 transition-all rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] flex items-center justify-start gap-x-4 cursor-pointer">
                    <Link
                      className="flex items-center justify-start gap-x-4 w-full"
                      to={"/election"}
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <span className=" w-3 h-auto xs:w-4">
                        <SVG_ElectionIcon
                          width={21}
                          height={20}
                          className="election"
                        />
                      </span>
                      <span className=" font-medium text-sm xs:text-base">
                        Election
                      </span>
                    </Link>
                  </li>
                )}
                {isSportAvailable("QT") && (
                  <>
                    <li className="px-3 py-2 transition-all rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] flex items-center justify-start gap-x-4 cursor-pointer">
                      <Link
                        className="flex items-center justify-start gap-x-4 w-full"
                        to={userData?.is_demo ? "#" : "/livegames/aura/FAWK"}
                        onClick={() => {
                          if (userData?.is_demo) {
                            toastr.error("", "Please login from your read ID.");
                            return;
                          }
                          setOpen(false);
                        }}
                      >
                        <span className=" w-3 h-auto xs:w-4">
                          <Svg_SpadeIcon
                            width={15}
                            height={16}
                            className="election"
                          />
                        </span>
                        <span className=" font-medium text-sm xs:text-base">
                          Indian Card Games
                        </span>
                      </Link>
                    </li>
                    <li className="px-3 py-2 transition-all rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] flex items-center justify-start gap-x-4 cursor-pointer">
                      <Link
                        to={"#"}
                        className="flex items-center justify-start gap-x-4 w-full"
                        onClick={(e) => {
                          e.preventDefault();
                          setOpen(false);
                          if (auth) {
                            if (userData?.is_demo) {
                              toastr.error(
                                "",
                                "Please login from your read ID."
                              );
                              return;
                            }
                            navigate("/casino-lobby/casino");
                            if (
                              !location.pathname.includes(
                                "/casino-lobby/casino"
                              )
                            ) {
                              actions.openSlotCasinoPopUp();
                            }
                          } else {
                            actions.setLoginNew(true);
                            actions.setLoginNavigationData({
                              page: "casino-lobby/casino",
                              ids: [],
                            });
                          }
                        }}
                      >
                        <span className=" w-3 h-auto xs:w-4">
                          <SVG_CardDeckIcon width={15} height={16} />
                        </span>
                        <span className=" font-medium text-sm xs:text-base">
                          Casino
                        </span>
                      </Link>
                    </li>
                    <li className="px-3 py-2 transition-all rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] flex items-center justify-start gap-x-4 cursor-pointer">
                      <Link
                        to={"#"}
                        className="flex items-center justify-start gap-x-4 w-full"
                        onClick={(e) => {
                          e.preventDefault();
                          setOpen(false);
                          if (auth) {
                            if (userData?.is_demo) {
                              toastr.error(
                                "",
                                "Please login from your read ID."
                              );
                              return;
                            }
                            navigate("/casino-lobby/slot-games");
                            if (
                              !location.pathname.includes(
                                "/casino-lobby/slot-games"
                              )
                            ) {
                              actions.openSlotCasinoPopUp();
                            }
                          } else {
                            actions.setLoginNew(true);
                            actions.setLoginNavigationData({
                              page: "casino-lobby/slot-games",
                              ids: [],
                            });
                          }
                        }}
                      >
                        <span className=" w-3 h-auto xs:w-4">
                          <SVG_DiceIcon width={17} height={16} />
                        </span>
                        <span className=" font-medium text-sm xs:text-base">
                          Slot Games
                        </span>
                      </Link>
                    </li>
                  </>
                )}
                <li className="px-3 py-2 transition-all rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] flex items-center justify-start gap-x-4 cursor-pointer">
                  <a
                    className="flex items-center justify-start gap-x-4 w-full"
                    href="/download-apk"
                  >
                    <span className=" w-3 h-auto xs:w-4">
                      <SVG_DownloadIcon />
                    </span>
                    <span className=" font-medium text-sm xs:text-base">
                      Download APK
                    </span>
                  </a>
                </li>
                <li className=" px-3 py-2">
                  <span className="flex text-center text-text_Primary text-sm xs:text-base font-medium">
                    Register online and play online
                  </span>
                </li>

                {location?.pathname == "/" && CONFIG.isContactUsVisisble && (
                  <ContactUs section={"Sidebar"} />
                )}
              </ul>
            </div>
          </div>
        </div>
      </aside> */}
    </>
  );
};

export default connectLeftSideMenu()(LeftSideMenu);
